const ProfileIcon = (
  <>
    <path
      d="M12.5 12.5H7.5C4.73875 12.5 2.5 14.7388 2.5 17.5V18.3333C2.5 18.3333 5.10417 19.1667 10 19.1667C14.8958 19.1667 17.5 18.3333 17.5 18.3333V17.5C17.5 14.7388 15.2612 12.5 12.5 12.5Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 5.16667C5.5 2.86542 7.36542 1 9.66667 1C11.9679 1 13.8333 2.86542 13.8333 5.16667C13.8333 7.46792 11.9679 10.1667 9.66667 10.1667C7.36542 10.1667 5.5 7.46792 5.5 5.16667Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export default ProfileIcon
